var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSosBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.458,
    height: 37.095,
    viewBox: "0 0 32.458 37.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-building",
    "data-name": "Icon awesome-building",
    d: "M31.588,34.776H30.139V1.739A1.739,1.739,0,0,0,28.4,0H4.057A1.739,1.739,0,0,0,2.318,1.739V34.776H.869A.869.869,0,0,0,0,35.646v1.449H32.458V35.646A.869.869,0,0,0,31.588,34.776ZM9.274,5.506a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869V8.4a.869.869,0,0,1-.869.869h-2.9A.869.869,0,0,1,9.274,8.4Zm0,6.955a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869v2.9a.869.869,0,0,1-.869.869h-2.9a.869.869,0,0,1-.869-.869Zm3.767,10.723h-2.9a.869.869,0,0,1-.869-.869v-2.9a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869v2.9A.869.869,0,0,1,13.041,23.184Zm5.506,11.592H13.911V28.69a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869Zm4.637-12.462a.869.869,0,0,1-.869.869h-2.9a.869.869,0,0,1-.869-.869v-2.9a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869Zm0-6.955a.869.869,0,0,1-.869.869h-2.9a.869.869,0,0,1-.869-.869v-2.9a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869Zm0-6.955a.869.869,0,0,1-.869.869h-2.9a.869.869,0,0,1-.869-.869v-2.9a.869.869,0,0,1,.869-.869h2.9a.869.869,0,0,1,.869.869Z",
    fill: "#ed726f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosBuildingIcon);
export default __webpack_public_path__ + "static/media/SOSBuildingIcon.f65932debeb39d06badae747b6f5c7e1.svg";
export { ForwardRef as ReactComponent };